import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import httpr from "../../lib/httpRequest";
import { BASE_URL } from "../../lib/config";

import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Griddle, {
  ColumnDefinition,
  RowDefinition,
  plugins,
} from "griddle-react";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader";
import CardBody from "components/Card/CardBody.jsx";
import Button from "components/CustomButtons/Button.jsx";
import ReactLoading from "react-loading";

import withStyles from "@material-ui/core/styles/withStyles";
import tableStyle from "assets/jss/material-dashboard-react/components/tableStyle";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";

const styles = (theme) => ({
  daysColumn: {
    wordWrap: "break-word",
    width: "1px",
    color: "blue",
  },
  dialogControl: {
    width: "100%",
  },
  tableContainer: {
    overflowX: "scroll",
  },
});

const SettingsLayout = ({ Table, Pagination }) => (
  <div>
    <Table />
    <Pagination />
  </div>
);

class SettingsTable extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);

    this.state = {
      tableData: [],
      loading: true,
      rowData: {},
      editOpen: false,
      deletePromptOpen: false,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    if (this.props.type === "report") {
      this.getReportSettingsForMember();
    } else {
      this.getAlertSettingsForMember();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  /* GETTERS */
  getAlertSettingsForMember = () => {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);
    fetch
      .get(`${BASE_URL}/api/members/settings/alert/${this.props.type}`)
      .then((response) => {
        let data = this.formatLocationName(response.data);
        if (this._isMounted === true) {
          this.setState({ tableData: data, loading: false });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getReportSettingsForMember = () => {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);
    fetch
      .get(`${BASE_URL}/api/members/settings/report/${this.props.memberId}`)
      .then((response) => {
        let data = this.formatReportName(response.data);
        data = this.formatLocationName(data);
        if (this._isMounted === true) {
          this.setState({ tableData: data, loading: false });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  formatLocationName = (reportData) => {
    reportData.map((settingObj) => {
      let temp = settingObj.LocationName.replace(/_/g, " ");
      settingObj.LocationName = temp;
    });

    return reportData;
  };

  // ie. GRAND_TOTALS >> Grand Totals
  formatReportName = (reportData) => {
    reportData.map((settingObj) => {
      // Format report names
      let temp = "";
      settingObj["report"].split("_").map((word, index) => {
        if (index != settingObj["report"].split("_").length - 1) {
          temp +=
            word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() + " ";
        } else {
          temp += word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }
      });
      settingObj["report"] = temp;
    });
    return reportData;
  };

  /* HANDLE FUNCTIONS */
  handleEditClicked = (rowData) => {
    // call parent function
    this.props.handleEditSetting(rowData);
  };
  handleDeleteClicked = (rowData) => {
    //open prompt dialogue
    this.setState({ deletePromptOpen: true, rowData: rowData });
  };
  handleDeletePromptClose = () => {
    this.setState({ deletePromptOpen: false });
  };
  handleDeleteSetting = () => {
    this.setState({ deletePromptOpen: false });
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    // send ID to backend to delete
    const ID = this.state.rowData.ID;

    if (this.props.type === "report") {
      fetch
        .put(`${BASE_URL}/api/members/settings/report/delete/${ID}`)
        .then((response) => {
          if (response.status === 200) {
            // update the table data
            this.getReportSettingsForMember();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      fetch
        .put(`${BASE_URL}/api/members/settings/alert/delete/${ID}`)
        .then((response) => {
          if (response.status === 200) {
            // update the table data
            this.getAlertSettingsForMember();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  render() {
    const { classes } = this.props;

    /* EDIT AND DELETE */
    // Griddle helper functions to get data from row into cell
    const rowDataSelector = (state, { griddleKey }) => {
      return state
        .get("data")
        .find((rowMap) => rowMap.get("griddleKey") === griddleKey)
        .toJSON();
    };

    const enhancedWithRowData = connect((state, props) => {
      return {
        rowData: rowDataSelector(state, props),
      };
    });

    const EditDeleteColumn = ({ value, griddleKey, rowData }) => {
      return (
        <div>
          <Tooltip
            id="tooltip-top"
            title="Edit Setting"
            placement="top"
            classes={{ tooltip: classes.tooltip }}
          >
            <IconButton
              onClick={() => {
                this.handleEditClicked(rowData);
              }}
              aria-label="Edit"
              className={classes.tableActionButton}
            >
              <Edit
                className={classes.tableActionButtonIcon + " " + classes.edit}
              />
            </IconButton>
          </Tooltip>

          <Tooltip
            id="tooltip-top-start"
            title="Delete Setting"
            placement="top"
            classes={{ tooltip: classes.tooltip }}
          >
            <IconButton
              onClick={() => {
                this.handleDeleteClicked(rowData);
              }}
              aria-label="Close"
              className={classes.tableActionButton}
            >
              <Close
                className={classes.tableActionButtonIcon + " " + classes.close}
              />
            </IconButton>
          </Tooltip>
        </div>
      );
    };

    /* TABLE STYLES */
    const styleConfig = {
      icons: {
        TableHeadingCell: {
          sortDescendingIcon: <div />,
          sortAscendingIcon: <div />,
        },
      },
      classNames: {
        Table: `${classes.table}`,
        TableHeadingCell: `${classes.tableHeadCell}`,
        TableHeading: `${classes["primaryTableHeader"]}`,
        TableBody: `${classes.tableResponsive}`,
        Cell: `${classes.tableCell}`,
        Row: `${classes.tableRow}`,
      },
    };

    /* FORMAT TABLE */
    let tableTitle = "";
    let tableRowDef = <RowDefinition />;

    if (this.props.type === "error") {
      tableTitle = "Machine Error Alert Settings";

      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition id="ErrorAlertType" title="Type" />
          <ColumnDefinition id="RECYCLER_ID" title="Terminals" />
          <ColumnDefinition
            id="DaysToNotify"
            title="Days to Notify"
            cssclassName={styles.daysColumn}
          />
          <ColumnDefinition id="AllDay" title="All Day" />
          <ColumnDefinition id="StartHour" title="Start Hour" />
          <ColumnDefinition id="EndHour" title="End Hour" />
          <ColumnDefinition id="ErrorDelay" title="Delay" />
          <ColumnDefinition id="ErrorRepeats" title="Repeats" />
          <ColumnDefinition id="ErrorInterval" title="Interval" />
          <ColumnDefinition id="LocationName" title="Location" />
          <ColumnDefinition
            width={"10%"}
            id=""
            title=""
            customComponent={enhancedWithRowData(EditDeleteColumn)}
          />
        </RowDefinition>
      );


    }

    if (this.props.type === "replication") {
      tableTitle = "Replication Status Alert Settings";

      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition id="RECYCLER_ID" title="Terminals" />
          <ColumnDefinition id="DaysToNotify" title="Days to Notify" />
          <ColumnDefinition id="AllDay" title="All Day" />
          <ColumnDefinition id="StartHour" title="Start Hour" />
          <ColumnDefinition id="EndHour" title="End Hour" />
          <ColumnDefinition id="ReplicationDelay" title="Delay" />
          <ColumnDefinition id="LocationName" title="Location" />
          <ColumnDefinition
            width={"10%"}
            id=""
            title=""
            customComponent={enhancedWithRowData(EditDeleteColumn)}
          />
        </RowDefinition>
      );
    }

    if (this.props.type === "openTill") {
      tableTitle = "Open Till Alert Settings";

      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition id="RECYCLER_ID" title="Terminals" />
          <ColumnDefinition id="DaysToNotify" title="Days to Notify" />
          <ColumnDefinition id="AllDay" title="All Day" />
          <ColumnDefinition id="StartHour" title="Start Hour" />
          <ColumnDefinition id="EndHour" title="End Hour" />
          <ColumnDefinition id="OpenTillDelay" title="Delay" />
          <ColumnDefinition id="LocationName" title="Location" />
          <ColumnDefinition
            width={"10%"}
            id=""
            title=""
            customComponent={enhancedWithRowData(EditDeleteColumn)}
          />
        </RowDefinition>
      );
    }

    if (this.props.type === "threshold") {
      tableTitle = "Threshold Alert Settings";

      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition id="RECYCLER_ID" title="Terminals" />
          <ColumnDefinition id="DaysToNotify" title="Days to Notify" />
          <ColumnDefinition id="AllDay" title="All Day" />
          <ColumnDefinition id="StartHour" title="Start Hour" />
          <ColumnDefinition id="EndHour" title="End Hour" />
          <ColumnDefinition id="UNIT_ID" title="Cassettes" />
          <ColumnDefinition id="DENOMINATION" title="Denominations" />
          <ColumnDefinition id="MinThreshold" title="Minimum" />
          <ColumnDefinition id="MaxThreshold" title="Maximum" />
          <ColumnDefinition id="LocationName" title="Location" />
          <ColumnDefinition
            width={"10%"}
            id=""
            title=""
            customComponent={enhancedWithRowData(EditDeleteColumn)}
          />
        </RowDefinition>
      );
    }

    if (this.props.type === "report") {
      tableTitle = "Auto Report Settings";

      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition id="LocationName" title="Location" />
          <ColumnDefinition id="report" title="Report" />
          <ColumnDefinition id="StartHour" title="Time to Send" />
          <ColumnDefinition id="DaysToNotify" title="Days to Send" />
          <ColumnDefinition id="MinusDays" title="Days to Inlcude" />
          <ColumnDefinition id="terminalId" title="Terminals" />
          <ColumnDefinition id="vaultId" title="Vaults" />
          <ColumnDefinition id="functionLevel" title="Function Level" />
          <ColumnDefinition id="userLevel" title="User Level" />
          <ColumnDefinition id="showDelete" title="Show Deleted" />
          <ColumnDefinition id="userSummaryCheck" title="Overnight Shifts" />
          <ColumnDefinition id="openTillDelay" tite="Open Till Delay" />
          <ColumnDefinition
            width={"10%"}
            id=""
            title=""
            customComponent={enhancedWithRowData(EditDeleteColumn)}
          />
        </RowDefinition>
      );
    }

    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="success">
                <h4 className={classes.cardTitleWhite}>{tableTitle}</h4>
              </CardHeader>
              <CardBody>
                {this.state.loading ? (
                  <ReactLoading
                    type="spin"
                    color="#000000"
                    style={{
                      width: "20%",
                      margin: "auto",
                    }}
                  />
                ) : (
                  <div className={classes.tableContainer}>
                    <Griddle
                      data={this.state.tableData}
                      plugins={[plugins.LocalPlugin]}
                      key={`${this.props.type}`}
                      styleConfig={styleConfig}
                      components={{
                        Layout: SettingsLayout,
                      }}
                      pageProperties={{
                        pageSize: 20,
                      }}
                    >
                      {tableRowDef}
                    </Griddle>
                  </div>
                )}
                <Dialog
                  open={this.state.deletePromptOpen}
                  onClose={this.handleDeletePromptClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                  className={classes.dialogControl}
                >
                  <DialogTitle id="alert-dialog-title">
                    {"Delete setting?"}
                  </DialogTitle>
                  <DialogActions>
                    <Button
                      onClick={this.handleDeletePromptClose}
                      color="primary"
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={this.handleDeleteSetting}
                      color="primary"
                      autoFocus
                    >
                      Delete
                    </Button>
                  </DialogActions>
                </Dialog>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

SettingsTable.defaultProps = {
  tableHeaderColor: "gray",
};

SettingsTable.propTypes = {
  classes: PropTypes.object.isRequired,
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "scmain",
    "info",
    "rose",
    "gray",
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(PropTypes.object),
};

export default withStyles(tableStyle)(SettingsTable);



// WEBPACK FOOTER //
// ./src/components/Alerts/SettingsTable.jsx